import CmpFileInput from "./CmpFileInput";

export default CmpFileInput;